(function () {
  'use strict';

  var CARD_CACHE_REGEX = /cards\/(\d+)\/cache$/;
  function getCardIdFromClearUrl(clearUrl) {
    var match = CARD_CACHE_REGEX.exec(clearUrl);
    if (match && match[1]) {
      return parseInt(match[1]);
    }
  }
  angular.module('wsLrs.directives').directive('wsDetailPagenote', ['$window', 'Logger', 'Api', 'CardRegistry', '$http', '$route', 'User', 'UserRoles', 'Utils', 'Alerts', '$location', function ($window, Logger, Api, CardRegistry, $http, $route, User, UserRoles, Utils, Alerts, $location) {
    /**
     * @param {object} cfg - Optional config object passed to the directive
     * @param {function} cfg.setReportMetaData - Optional function which, when called, will pass report
     *                                           metadata to the directive
     */

    return {
      templateUrl: "modules/common/directives/card-detail-pagenote/card-detail-pagenote.html",
      scope: {
        cfg: "=?"
      },
      link: function link(scope) {
        scope.cfg = scope.cfg || {};
        if (scope.$parent.cardId === 'preview') {
          scope.preview = true;
        }
        Logger.trace("ws-detail-pagenote:init");
        scope.clearCacheAction = scope.cfg.clearCacheAction;
        scope.displayPossibleError = scope.cfg.displayPossibleError;
        if (typeof scope.clearCacheAction === "string") {
          var clearUrl = scope.clearCacheAction;
          scope.clearCacheAction = function () {
            $http.delete(Api.url(clearUrl)).then(function () {
              // Update card registry to cache bust browser cache
              var cardId = getCardIdFromClearUrl(clearUrl),
                card = CardRegistry.get(cardId);
              if (card) {
                card.updated = new Date().toISOString();
                CardRegistry.add(card);
              }
              if (scope.cfg.windowReload) {
                $window.location.reload();
              } else {
                $route.reload();
              }
            });
          };
        }
        scope.getDataSearchLink = function getDataSearchLink() {
          // Get the first id in the url path, this is the card id and avoids issues with program report
          var cardId = $location.path().match(/\d+/);
          if (cardId) {
            var card = CardRegistry.get(parseInt(cardId[0]));
            var config = Utils.getIn(card, ['configuration'], {
              alt: {}
            });
            var configFilter = Utils.getIn(config, ['filter'], {
              alt: {}
            });
            var andFilter = Utils.getIn(config, ['filter', 'and'], {
              alt: []
            });
            var customFilters = Utils.getIn(config, ['customFilters'], {
              alt: []
            });
            var compoundFilter = Object.assign({}, configFilter, {
              and: andFilter.concat(customFilters)
            });
            return '#/data/search?filter=' + encodeURIComponent(JSON.stringify(compoundFilter));
          }
        };

        // Don't allow download of interactions from unauthenticated share
        var isShare = User.get().user === undefined || !User.get().user;
        if (isShare) {
          delete scope.downloadAction;
          delete scope.clearCacheAction;
        }
        var user = User.get();
        scope.isOrgManager = UserRoles.isOrgManager(user);
        function buildEstimatedResultsMessage(reportResult) {
          try {
            var stats = Utils._try(function () {
              return reportResult.results[0].result.stats || [];
            }, []);
            var estimatedMeasures = stats.filter(function (measure) {
              return measure.precisionThreshold !== undefined;
            }).map(function (measure) {
              return measure.displayName;
            });
            var measureList;
            if (estimatedMeasures.length === 1) {
              measureList = estimatedMeasures[0] + " is ";
            } else if (estimatedMeasures.length > 1) {
              measureList = estimatedMeasures.slice(0, estimatedMeasures.length - 1).join(', ');
              measureList += " and " + estimatedMeasures[estimatedMeasures.length - 1] + " are ";
            }
            if (estimatedMeasures.length > 0) {
              var learnMoreLink = "<a target=\"_blank\" href='https://watershedlrs.zendesk.com/hc/en-us/articles/360018675412#aggregation-precision-threshold'>Learn More</a>";
              scope.estimateMessage = measureList + "calculated using an algorithm that approximates values for efficiency, typically within 1% of precise values. ".concat(learnMoreLink);
            }
          } catch (e) {
            Logger.error("".concat(e));
          }
        }
        scope.cfg.setReportMetadata = function (reportResult) {
          Logger.trace('ws-detail-pagenote:setReportMetaData');
          var cardId = getCardIdFromClearUrl(clearUrl);
          var card = cardId !== null ? CardRegistry.get(cardId) : null;
          scope.statementCount = reportResult.processedHits;
          scope.includesPersonDocs = Utils._try(function () {
            return card !== null && card.configuration.includePeopleWithoutStatements;
          }, true);
          scope.totalStatements = reportResult.totalHits;
          scope.possibleError = reportResult.possibleError;
          scope.preview = scope.statementCount !== scope.totalStatements;
          scope.calculatedOn = moment.utc(reportResult.calculatedOn).fromNow();
          scope.duration = moment.duration(reportResult.durationMillis).humanize();

          // Currently used as a means of display a very visible warning about reaching the 10,000
          // limit for personIds on peopleFilter.
          if (reportResult.hasOwnProperty("warning") && reportResult.warning.length > 0) {
            Alerts.raiseAlert({
              "type": "danger",
              "text": reportResult.warning
            });
          }
          buildEstimatedResultsMessage(reportResult);
          if (reportResult.refreshStartedOn) {
            scope.refreshStartedOn = moment.utc(reportResult.refreshStartedOn).fromNow();
            var readyDate = moment.utc(reportResult.refreshStartedOn).add(reportResult.durationMillis);
            if (readyDate < moment.utc().add(2000)) {
              scope.readyInAbout = 'now';
            } else {
              scope.readyInAbout = readyDate.fromNow();
            }
          }
        };
      }
    };
  }]);
})();
